enum CitizenType {
  Citizenship = 'citizenship',
  ResidentPermit = 'residentPermit',
  Foreigner = 'foreigner',
}

export default CitizenType;
